if (window.location.href.indexOf('_gl=') > -1) {
    const url = new URL(window.location);
    url.searchParams.delete('_gl');
    window.history.replaceState({}, document.title, url.pathname + url.search);
}